namespace GeniuzPOS.Lookups {
    export namespace VpsPaymenTypeService {
        export const baseUrl = 'Lookups/VpsPaymenType';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VpsPaymenTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VpsPaymenTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VpsPaymenType/Retrieve",
            List = "Lookups/VpsPaymenType/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VpsPaymenTypeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
